<template>
    <v-layout row wrap>
        <v-flex xs12 v-if="loading">
            <v-progress-linear :indeterminate="true"></v-progress-linear>
        </v-flex>
        <v-flex xs12 v-if="!loading">
            <v-card flat v-if="facility_name">
                <v-card-title class="primary white--text headline">
                    Number of Observations
                </v-card-title>
                <v-layout row wrap class="pt-3">
                    <v-flex xs1>
                    </v-flex>
                    <v-flex xs11 class="text-xs-center">
                        Total Cooling Load (bin)
                    </v-flex>
                </v-layout>
                <v-data-table
                        :headers="headers"
                        :items="data"
                        hide-actions
                >
                    <template v-slot:items="props">
                        <td>
                            {{ props.item.temp }}
                        </td>
                        <td v-for="clunit in cl" v-bind:key=" props.item.temp+clunit">
                            <span class="pre-read"> {{ props.item[clunit].pre }}</span><br/>
                            <span class="post-read">{{ props.item[clunit].post }}</span>
                        </td>
                    </template>
                    <template v-slot:footer>
                        <td :colspan="headers.length" class="text-xs-right pt-3 pb-3">
                            <span class="pre-read"> Before optimisation</span><br/>
                            <span class="post-read">After optimisation</span>
                        </td>
                    </template>
                </v-data-table>

            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
    import {getCOP} from '@/helper'
    import moment from 'moment'
    export default {
        name: 'Observations',
        components: {},
        computed: {
            facility_name() {
                return this.$store.state.pointsListStore.pointsList.facility_name
            },

            oatVar(){
                if(this.$store.state.pointsListStore.pointsList.facility_name==="CRP"){
                    return 'Temperature';
                } else {
                    return 'Outdoor_Temperature';
                }

            },
            cutOff(){
                if(this.$store.state.pointsListStore.pointsList.facility_name==="CRP"){
                    return "2020-09-18 00:00:00";
                } else {
                    return "2019-09-18 00:00:00";
                }

            },
            headers() {

                return [
                    {
                        text: 'Temperature (°C)',
                        align: 'left',
                        sortable: false,
                        value: 'temp'
                    },
                    ...this.cl.map(cl=>{
                        return ({
                            text: cl.toString(),
                            align: 'left',
                            sortable: false,
                            value: cl.toString()
                        })
                    })
                ]


            }
        },
        data () {
            return {
                data:null,
                cl:null,
                loading:true,

            }
        },

        async mounted() {
            let preCOP= await getCOP({
                facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
                from_date: moment().subtract(10,'years').format('YYYY-MM-DD HH:mm'),
                to_date: this.cutOff,
                'agg_obs':this.oatVar,
                'extra_vars': [
                    {
                        'equipment_name': 'Weather',
                        'sensor_names': [this.oatVar]
                    }
                ]
            })
            let postCOP= await getCOP({
                facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
                from_date: this.cutOff,
                to_date: moment().add(10,'years').format('YYYY-MM-DD HH:mm'),
                'agg_obs':this.oatVar,
                'extra_vars': [
                    {
                        'equipment_name': 'Weather',
                        'sensor_names': [this.oatVar]
                    }
                ]
            })
            let finalobj={}
            for (let k in preCOP){
                if(!finalobj[k]){
                    finalobj[k]={}
                }
                for (let s in preCOP[k]){
                    if(!finalobj[k][s]){
                        finalobj[k][s]={}
                    }
                    finalobj[k][s].pre=preCOP[k][s]
                }
            }
            for (let k in postCOP){
                if(!finalobj[k]){
                    finalobj[k]={}
                }
                for (let s in postCOP[k]){
                    if(!finalobj[k][s]){
                        finalobj[k][s]={}
                    }
                    finalobj[k][s].post=postCOP[k][s]
                }
            }
            let data=[]
            let cl=null;
            for (let k in finalobj){
                if(!cl){
                    cl=Object.keys(finalobj[k])
                }
                finalobj[k].temp=k;
                data.push(finalobj[k])
            }
            this.cl=cl;
            this.data=data;
            this.loading=false;
        }


    }
</script>
<style>
    .green-icon .theme--light.v-icon{
        color: #77C16B;
    }
    .pre-read{
        color:rgb(31, 119, 180);
    }
    .post-read{
        color:rgb(255, 127, 14);
    }
</style>
